import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

// Entra sign-in lands here with the token in the URL fragment
// (/auth/callback#token=...). The fragment is never sent to a server or put
// in a Referer. Read it, remove it from the address bar and history at once,
// then load the app fresh so AuthContext picks up the session.
export default function AuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');
    window.history.replaceState(null, '', window.location.pathname);

    if (token) {
      // Same key as AuthContext and api.js
      localStorage.setItem('pilot_token', token);
      window.location.replace('/');
    } else {
      window.location.replace('/login?error=no_token');
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#faf8fb]">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#98139C] mx-auto mb-4" />
        <p className="text-[#30302F]/80">Completing sign in...</p>
      </div>
    </div>
  );
}
